module.exports = __webpack_public_path__ + "img/simpleVector-reverse.dd746da4.svg";